import React from "react";

import Skeleton from "@mui/material/Skeleton";

import * as Styles from "./styles";

const TableSkeleton = () => {
  const skeletonRows = () => {
    const rows = [];
    // eslint-disable-next-line no-unreachable-loop, no-plusplus
    for (let index = 0; index < 10; index++) {
      rows.push(
        <Styles.Row style={{ marginBottom: 2 }} key={index}>
          <Skeleton
            variant="rectangular"
            width="12.5%"
            height={40}
            style={{ marginRight: 2 }}
          />
          <Skeleton
            variant="rectangular"
            width="12.5%"
            height={40}
            style={{ marginRight: 2 }}
          />
          <Skeleton
            variant="rectangular"
            width="12.5%"
            height={40}
            style={{ marginRight: 2 }}
          />
          <Skeleton
            variant="rectangular"
            width="12.5%"
            height={40}
            style={{ marginRight: 2 }}
          />
          <Skeleton
            variant="rectangular"
            width="12.5%"
            height={40}
            style={{ marginRight: 2 }}
          />
          <Skeleton
            variant="rectangular"
            width="12.5%"
            height={40}
            style={{ marginRight: 2 }}
          />
          <Skeleton
            variant="rectangular"
            width="12.5%"
            height={40}
            style={{ marginRight: 2 }}
          />
          <Skeleton variant="rectangular" width="12.5%" height={40} />
        </Styles.Row>
      );
    }
    return rows;
  };
  return <>{skeletonRows()}</>;
};

export default TableSkeleton;
